export const payment = {
  title: 'Méthode de paiement',
  card: 'Carte',
  eps: 'EPS',
  giropay: 'Giropay',
  card_number: 'Numéro de carte',
  expiry: 'Expiration',
  cvc: 'CVC',
  country: 'Pays',
  postal_code: 'Code postal',
  next: 'Suivant',
  countries: {
    us: 'États-Unis',
    fr: 'France',
    de: 'Allemagne',
  },
}
